import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserLink from '@wix/da-shared-react/pkg/User/Link/UserLink';

import s from './ExclusiveOwner.scss';

interface Props {
  deviation: PapiDeviation;
}

const ExclusiveOwner: FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const owner = deviation.adoptable?.owner;
  if (!owner || owner.userId === deviation.author?.userId) {
    return null;
  }

  return (
    <div className={s['root']}>
      {t('studio.products.exclusive.owner', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        userLink: <UserLink className={s['user-link']} user={owner} showSymbol={false} />,
      })}
      <ResaleIcon className={s['resale-icon']} size={IconSize.SMALL} />
    </div>
  );
};
ExclusiveOwner.displayName = 'ExclusiveOwner';

export default ExclusiveOwner;
